/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {accounting} from 'accounting'
import Page from '../Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import moment from 'moment'
import $ from 'jquery'
import {ExcelExport, grid, gridColumn, gridToolbar} from '@progress/kendo-react-excel-export'
import {message} from 'antd'
import cookie from 'react-cookies'
import Select from 'react-select'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import FromToPicker from '../BaseComponent/FromToPicker'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import SearchProduct from '../BaseComponent/SearchProduct'
import Loader from '../loaders/loader'
import Pageing from '../Pagination/pageing'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import SearchableCombo from '../BaseComponent/searchableCombo'
import AutoComplete from '../BaseComponent/autocomplete'

class SuppliedNotice extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      lengthbaskets: 0,
      selectedDateFrom: moment(),
      selectedDateTo: moment(),
      supplierOrder: [],
      providers: [],
      printInfo: [],
      selectedOption: [],
      excelData: [],
      fromDate: '',
      toDate: '',
      toExpected: '',
      fromExpected: '',
      aggregation: {},
      buttonClicked: false,
      itemInfo: {},
      products: [],
      providerId: '',
      productId: '',
      pageNumber: 1,
      pageSize: 10,
      sortBy: 'noticeDate_desc',
      sortData: [
        {
          name: 'ردیف',
          value: 'index',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تامین کننده',
          value: 'providerName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'زمان اطلاع رسانی',
          value: 'noticeDate',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'زمان انتظار تحویل',
          value: 'expectedDate',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'زمان پردازش',
          value: 'processTime',
          sorted: false,
          direction: null,
          sortable: true
        }
      ],
      tablePageNumber: 1
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_SUPPLIED_NOTICE}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          if (!exportStatus) {
            $('.showBaseTable,.print').fadeIn()

            this.setState({
              tablePageNumber: this.state.pageNumber,
              tablePageSize: this.state.pageSize,
              supplierOrder: response.data.object.result,
              countAll: response.data.object.countAll,
              toPrintDate: this.state.fromDate == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
              fromPrintDate: this.state.toDate == '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
              buttonClicked: true,
              loading: false
            })
          } else {
            this.setState({
              printInfo: response.data.object.result,
              loading: false
            })
          }
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            loading: false
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    let noticeDateMin = this.state.fromDate
    let noticeDateMax = this.state.toDate
    let expectedDateMin = this.state.fromExpected
    let expectedDateMax = this.state.toExpected
    let providerId = this.state.providerId
    let processTimeMin = this.convertDigit(document.getElementById('processTimeMin').value.trim())
    let processTimeMax = this.convertDigit(document.getElementById('processTimeMax').value.trim())

    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (noticeDateMin !== '') {
      filter.noticeDateMin = noticeDateMin
    }
    if (noticeDateMax !== '') {
      filter.noticeDateMax = noticeDateMax
    }
    if (expectedDateMin !== '') {
      filter.expectedDateMin = expectedDateMin
    }
    if (expectedDateMax !== '') {
      filter.expectedDateMax = expectedDateMax
    }
    if (providerId !== '') {
      filter.providerId = providerId
    }
    if (processTimeMin !== '') {
      filter.processTimeMin = processTimeMin
    }
    if (processTimeMax !== '') {
      filter.processTimeMax = processTimeMax
    }
    return filter
  }

  componentDidMount() {
    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {}).then((response) => {

    //     if (response.data.error == null) {

    //         var result = response.data.object;
    //         for (let i = 0; i < result.length; i++) {
    //             result[i]['value'] = result[i].providerId;
    //             result[i]['label'] = result[i].providerId +' - '+ result[i].title;
    //         }

    //         this.setState({
    //             providers: response.data.object
    //         })
    //     }
    //     // alert(JSON.stringify(response.data))
    // }).catch((error) => {
    //     alert(JSON.stringify(error))
    // });

    sessionStorage.removeItem('params')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  handleChangeFromDateExpected = (fromExpected) => {
    this.setState({
      fromExpected
    })
  }
  handleChangeToDateExpected = (toExpected) => {
    this.setState({
      toExpected
    })
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState({
        pageNumber: 1
      })
      setTimeout(() => {
        this.getReport(false)
      }, 500)
    }
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })
    this.getReport(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 landscape;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    let filter = this.createFilter()
    filter.export = true
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_SUPPLIED_NOTICE}`, {
        params: filter
      })
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })

          let {excelReport} = this.state
          excelReport.forEach((item) => {
            if (item.expectedDate !== null) {
              item.expectedDate =
                jMoment(item.expectedDate).format('jYYYY/jMM/jDD') + ' - ' + item.expectedTime.substr(0, 5)
            }
            if (item.noticeDate !== null) {
              item.noticeDate = jMoment(item.noticeDate).format('jYYYY/jMM/jDD') + ' - ' + item.noticeTime.substr(0, 5)
            }
            item.processTime = '  ' + item.processTime + '  ' + ' ساعت '
          })
          this._export.save(this.state.excelReport)
        }
        // else {
        //     $('.showBaseTable,.print').fadeOut();
        //     // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        // }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  getValueProvider = (providerId) => {
    if (providerId === null) {
      this.setState({
        products: [],
        providerId: null
      })
    } else {
      this.setState({
        providerId
      })
      // let id = providerId.providerId;
      //
      // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PRODUCT}?providerId=${id}`,{
      //
      // }).then(response=>{
      //     if(response.data.error === null){
      //         var products = response.data.object;
      //         for (let i = 0; i < products.length; i++) {
      //             products[i]['value'] = products[i].productId;
      //             products[i]['label'] = products[i].articleId + ' - ' +products[i].productName;
      //         }
      //         this.setState({
      //             products : response.data.object
      //         })
      //     }
      //     else{
      //         this.setState({
      //             products : []
      //         })
      //     }
      // })
    }
  }

  getValueProduct = (productId) => {
    if (productId === null) {
      this.setState({
        productId: ''
      })
    } else {
      this.setState({
        productId
      })
    }
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state
    let reporterName = cookie.load('name')

    let printCol = ['ردیف', 'تامین کننده', 'زمان اطلاع رسانی', 'زمان انتظار تحویل', 'زمان پردازش']

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />

        <div className="printSection">
          <table className="printTable printReportTable landscapeTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش اطلاع رسانی تامین کالا"
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={5}
              rightColSpan={2}
              centerColSpan={1}
              leftColSpan={2}
              centerSection={''}
              rightSection={'تاریخ اطلاع رسانی از : ' + this.state.toPrintDate + ' تا ' + this.state.fromPrintDate}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.providerName}</td>
                  <td>
                    <span>{item.noticeTime.substr(0, 5) + ' - '}</span>
                    <span>{item.noticeDate !== null && jMoment(item.noticeDate).format('jYYYY/jMM/jDD')}</span>
                  </td>
                  <td>
                    <span>{item.expectedTime.substr(0, 5) + ' - '}</span>
                    <span>{item.expectedDate !== null && jMoment(item.expectedDate).format('jYYYY/jMM/jDD')}</span>
                  </td>
                  <td>
                    <span>{item.processTime + ' ساعت '}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش اطلاع رسانی تامین کالا.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'providerName'}
                field={'providerName'}
                title={'تامین کننده'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'noticeDate'}
                field={'noticeDate'}
                title={'زمان اطلاع رسانی'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'expectedDate'}
                field={'expectedDate'}
                title={'زمان انتظار تحویل'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'processTime'}
                field={'processTime'}
                title={'زمان پردازش'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>سفارش تامین کنندگان</li>
            <li>اطلاع رسانی تامین کالا</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ اطلاع رسانی از"
                  toLabel="تاریخ اطلاع رسانی تا"
                  defaulValue={true}
                  fromId="from"
                  toId="to"
                />
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDateExpected}
                  onChangeToDate={this.handleChangeToDateExpected}
                  fromLabel="تاریخ انتظار تحویل از"
                  toLabel="تاریخ انتظار تحویل تا"
                  fromId="fromExpected"
                  toId="toExpected"
                />

                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <SearchableCombo
                                        options={this.state.providers}
                                        getValueCombo={this.getValueProvider}
                                        lableText='تامین کننده'
                                        placeholder='------'
                                        isClearable={true}
                                        isMulti={false}
                                        className='font-weight-bold'

                                    /> */}
                </div>
                <div className="formComponent">
                  <label>زمان پردازش از :</label>
                  <input type="number" className="form-control" id="processTimeMin" name="processTimeMin" />
                </div>
                <div className="formComponent">
                  <label>زمان پردازش تا :</label>
                  <input type="number" className="form-control" id="processTimeMax" name="processTimeMax" />
                </div>
                {/*<div className='formComponent'>*/}
                {/*    <SearchableCombo*/}
                {/*        options={this.state.products}*/}
                {/*        getValueCombo={this.getValueProduct}*/}
                {/*        lableText='کالا'*/}
                {/*        placeholder='------'*/}
                {/*        isClearable={true}*/}
                {/*        isMulti={false}*/}
                {/*        className='font-weight-bold'*/}
                {/*    />*/}
                {/*</div>*/}
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable" ref={(node) => (this.printTable = node)}>
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />

                  {this.state.supplierOrder.map((item, index) => (
                    <tr key={index}>
                      <td>{(this.state.tablePageNumber - 1) * this.state.tablePageSize + index + 1}</td>
                      <td>{item.providerName}</td>
                      <td>
                        <span>{item.noticeTime.substr(0, 5) + ' - '}</span>
                        <span>{item.noticeDate !== null && jMoment(item.noticeDate).format('jYYYY/jMM/jDD')}</span>
                      </td>
                      <td>
                        <span>{item.expectedTime.substr(0, 5) + ' - '}</span>
                        <span>{item.expectedDate !== null && jMoment(item.expectedDate).format('jYYYY/jMM/jDD')}</span>
                      </td>
                      <td>
                        <span>{item.processTime + ' ساعت '}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SuppliedNotice
